// schedule-lock — class-due-dates (Trello xx2znLE9): the page side of a class schedule lock on
// the assignment and challenge surfaces. A plain helper imported by `assignment-chrome.js` and
// `challenge-chrome.js` (not a uniformly-wired chrome module).
//
// The SERVER decides everything: the template emits `data-schedule-locked="true"` (and the
// banner) only when this activity is CLOSED for this student — past its class `dueAt` with its
// own lock on, or the whole class locked (Amendment 2), and no teacher release — and
// `data-schedule-exempt="true"` when the viewer
// is course staff / a class manager. The client never compares dates against its own clock.
//
// A locked page is a CLIENT-SIDE presentation only (draft saving is not server-gated for any
// type); the real refusals are the Submit / Check routes. An exempt viewer sees the identical
// banner but keeps every control live, because the server would never refuse their request.

export var LOCKED_MESSAGE_TAIL = '. Ask your teacher if you need more time.';

// Rewrite each banner <time> into the viewer's own locale + time zone (the same
// `toLocaleDateString()` the classroom's `_formatDate` uses). Leaves the ISO text on failure.
export function formatLockDates(doc) {
  var times = doc.querySelectorAll('.schedule-lock-date[datetime]');
  for (var i = 0; i < times.length; i++) {
    var iso = times[i].getAttribute('datetime');
    try {
      var d = new Date(iso);
      if (!isNaN(d.getTime())) { times[i].textContent = d.toLocaleDateString(); }
    } catch (e) { /* keep the ISO fallback */ }
  }
}

// { locked, exempt, enforce } — `enforce` is what a chrome module acts on: locked for a
// real student. Also formats the banner date as a side effect (idempotent).
export function readScheduleLock(doc) {
  var body = doc.body;
  var locked = body.getAttribute('data-schedule-locked') === 'true';
  var exempt = body.getAttribute('data-schedule-exempt') === 'true';
  if (locked) { formatLockDates(doc); }
  return { locked: locked, exempt: exempt, enforce: locked && !exempt };
}

// The banner's visible sentence, for a disabled control's `title` (so the tooltip and the
// banner can never disagree).
export function lockSentence(doc) {
  var banner = doc.getElementById('schedule-lock-banner');
  var p = banner && banner.querySelector('p');
  return p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
}

// Disable one action control and point it at the banner.
export function disableForLock(doc, btn) {
  if (!btn) { return; }
  btn.disabled = true;
  btn.setAttribute('aria-disabled', 'true');
  var sentence = lockSentence(doc);
  if (sentence) { btn.title = sentence; }
  if (doc.getElementById('schedule-lock-banner')) {
    btn.setAttribute('aria-describedby', 'schedule-lock-banner');
  }
}
